import React from 'react';
import './Card.css';

interface CardProps {
  variant?: 'default' | 'intro' | 'end';
  children: React.ReactNode;
  className?: string;
}

export function Card({
  variant = 'default',
  children,
  className = '',
}: CardProps) {
  const baseClasses = 'card';

  const variantClasses = {
    default: '',
    intro: 'card--intro',
    end: 'card--end',
  };

  const classes = [baseClasses, variantClasses[variant], className]
    .filter(Boolean)
    .join(' ');

  return <div className={classes}>{children}</div>;
}

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export function CardHeader({ children, className = '' }: CardHeaderProps) {
  return <div className={`card__header ${className}`}>{children}</div>;
}

interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}

export function CardContent({ children, className = '' }: CardContentProps) {
  return <div className={`card__content ${className}`}>{children}</div>;
}

interface CardContentWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export function CardContentWrapper({
  children,
  className = '',
}: CardContentWrapperProps) {
  return <div className={`card__content-wrapper ${className}`}>{children}</div>;
}
